const AuthEvents = {
  USER_SIGNED_UP: "user_signed_up",
  USER_LOGGED_IN: "user_logged_in",
  USER_LOGGED_OUT: "user_logged_out",
  LOGIN_FAILED: "login_failed",
  ACCOUNT_LOCKED_OUT: "account_locked_out",
} as const;

const OnboardingEvents = {
  ONBOARDING_STARTED: "onboarding_started",
  OBITUARY_SUBMITTED: "obituary_submitted",
  ONBOARDING_COMPLETED: "onboarding_completed",
  ONBOARDING_SCREEN_VIEWED: "onboarding_screen_viewed",
  ONBOARDING_SCREEN_COMPLETED: "onboarding_screen_completed",
  ONBOARDING_ANSWER_SUBMITTED: "onboarding_answer_submitted",
  ONBOARDING_HELP_EXPANDED: "onboarding_help_expanded",
  ONBOARDING_DOCUMENT_SKIPPED: "onboarding_document_skipped",
  ONBOARDING_DOCUMENT_UPLOADED: "onboarding_document_uploaded",
  ONBOARDING_DOCUMENT_REQUESTED: "onboarding_document_requested",
  ONBOARDING_SAVE_AND_CLOSE: "onboarding_save_and_close",
  ONBOARDING_SCREEN_SKIPPED: "onboarding_screen_skipped",
  ONBOARDING_REMIND_ME_LATER: "onboarding_remind_me_later",
  ONBOARDING_SCRAPE_RESULT: "onboarding_scrape_result",
  ONBOARDING_TRACERS_RESULT: "onboarding_tracers_result",
  PAYWALL_BOUNCE: "paywall_bounce",
  PAYWALL_DISMISSED: "paywall_dismissed",
  ONBOARDING_STEP_VIEWED: "onboarding_step_viewed",
  ONBOARDING_STEP_COMPLETED: "onboarding_step_completed",
  ONBOARDING_STEP_BACK_CLICKED: "onboarding_step_back_clicked",
  ONBOARDING_VALIDATION_FAILED: "onboarding_validation_failed",
  SIGNUP_SUBMITTED: "signup_submitted",
  SIGNUP_FAILED: "signup_failed",
  VERIFICATION_CODE_SENT: "verification_code_sent",
  VERIFICATION_CODE_FAILED: "verification_code_failed",
  ACCESS_CODE_SKIPPED: "access_code_skipped",
  DECEDENT_PATH_SELECTED: "decedent_path_selected",
  OBITUARY_SCRAPE_COMPLETED: "obituary_scrape_completed",
  DECEDENT_DETAILS_SAVED: "decedent_details_saved",
  ATTORNEY_REDIRECT_ANSWERED: "attorney_redirect_answered",
  IDENTITY_DOCUMENT_UPLOADED: "identity_document_uploaded",
  IDENTITY_VERIFICATION_COMPLETED: "identity_verification_completed",
  CLIENT_INVITE_VIEWED: "client_invite_viewed",
  CLIENT_INVITE_PLAN_SELECTED: "client_invite_plan_selected",
} as const;

const CheckoutEvents = {
  CHECKOUT_STARTED: "checkout_started",
  CHECKOUT_FAILED: "checkout_failed",
  CHECKOUT_RETURNED: "checkout_returned",
} as const;

const TriageEvents = {
  TRIAGE_OPENED: "triage_opened",
  TRIAGE_STEP_VIEWED: "triage_step_viewed",
  TRIAGE_STEP_COMPLETED: "triage_step_completed",
  TRIAGE_STEP_BACK_CLICKED: "triage_step_back_clicked",
  TRIAGE_STARTED: "triage_started",
  TRIAGE_DISMISSED: "triage_dismissed",
  DEATH_CERTIFICATE_METHOD_SELECTED: "death_certificate_method_selected",
  DEATH_CERTIFICATE_UPLOADED: "death_certificate_uploaded",
  DEATH_CERTIFICATE_UPLOAD_FAILED: "death_certificate_upload_failed",
  MOBILE_UPLOAD_SESSION_EXPIRED: "mobile_upload_session_expired",
  DEATH_CERTIFICATE_REQUESTED: "death_certificate_requested",
  DEATH_CERTIFICATE_EXTRACTION_COMPLETED: "death_certificate_extraction_completed",
  TRIAGE_DETAILS_CONFIRMED: "triage_details_confirmed",
  TRIAGE_AUTHORITY_SUBMITTED: "triage_authority_submitted",
  TRIAGE_COMPLETED: "triage_completed",
  AUTHORITY_CTA_CLICKED: "authority_cta_clicked",
} as const;

const EssentialsEvents = {
  ESSENTIALS_PAGE_VIEWED: "essentials_page_viewed",
  ESSENTIALS_MODULE_CLICKED: "essentials_module_clicked",
  ESSENTIALS_FORM_OPENED: "essentials_form_opened",
  ESSENTIALS_FORM_SUBMITTED: "essentials_form_submitted",
  ESSENTIALS_MODULE_COMPLETED: "essentials_module_completed",
  ESSENTIALS_PDF_DOWNLOADED: "essentials_pdf_downloaded",
  ESSENTIALS_GUIDE_PRINTED: "essentials_guide_printed",
  ESSENTIALS_INLINE_SUBMITTED: "essentials_inline_submitted",
} as const;

const ActivationEvents = {
  DASHBOARD_ACCESSED: "dashboard_accessed",
  FIRST_DOCUMENT_UPLOADED: "first_document_uploaded",
  FIRST_TASK_VIEWED: "first_task_viewed",
} as const;

const TaskEvents = {
  TASK_STARTED: "task_started",
  TASK_COMPLETED: "task_completed",
} as const;

const DocumentEvents = {
  DOCUMENT_VAULT_ACCESSED: "document_vault_accessed",
  DOCUMENT_UPLOADED: "document_uploaded",
  DOCUMENT_VIEWED: "document_viewed",
  DOCUMENT_DELETED: "document_deleted",
  ADD_DOCUMENT: "add_document",
  CHANGE_DOCUMENT_TYPE: "change_document_type",
  REMOVE_DOCUMENT: "remove_document",
  UPLOAD_DOCUMENTS: "upload_documents",
  UPLOAD_DOCUMENTS_SUCCESS: "upload_documents_success",
  UPLOAD_DOCUMENTS_FAILED: "upload_documents_failed",
} as const;

const PeopleEvents = {
  PEOPLE_SECTION_ACCESSED: "people_section_accessed",
  ADD_CONTACT_FORM_OPENED: "add_contact_form_opened",
  CONTACT_ADDED: "contact_added",
  FAMILY_MEMBER_INVITED: "family_member_invited",
  INVITE_MODAL_OPENED: "invite_modal_opened",
  INVITE_SENT: "invite_sent",
  INVITE_ACCEPTED: "invite_accepted",
} as const;

const AttorneyEvents = {
  LAWYER_CLIENT_INVITE_RESENT: "lawyer_client_invite_resent",
  ATTORNEY_INVITE_WIZARD_STEP_VIEWED: "attorney_invite_wizard_step_viewed",
  ATTORNEY_INVITE_WIZARD_STEP_COMPLETED: "attorney_invite_wizard_step_completed",
  LAWYER_ESTATE_ACCOUNT_VIEWED: "lawyer_estate_account_viewed",
  LAWYER_ESTATE_ACCOUNT_REMINDER_SENT: "lawyer_estate_account_reminder_sent",
  LAWYER_ESTATE_ACCOUNT_PDF_EXPORTED: "lawyer_estate_account_pdf_exported",
} as const;

const FeatureUsageEvents = {
  RESOURCES_ACCESSED: "resources_accessed",
  ESTATE_FINANCIALS_ACCESSED: "estate_financials_accessed",
  ESTATE_INVENTORY_DOWNLOADED: "estate_inventory_downloaded",
  FINANCIALS_GET_STARTED_CLICKED: "financials_get_started_clicked",
  FINANCIALS_SKIP_CLICKED: "financials_skip_clicked",
  FINANCIAL_ITEM_ADDED: "financial_item_added",
  FEATURE_ACTIVATED: "feature_activated",
  ACTION_PERFORMED: "action_performed",
  CONTENT_CREATED: "content_created",
  CONTENT_EDITED: "content_edited",
  CONTENT_DELETED: "content_deleted",
  SEARCH_PERFORMED: "search_performed",
  FAMILY_TRIAGE_COMPLETED: "family_triage_completed",
  PROBATE_STEP_COMPLETED: "probate_step_completed",
  PROBATE_FORMS_GENERATED: "probate_forms_generated",
  ADMIN_STEP_COMPLETED: "admin_step_completed",
} as const;

const NavigationEvents = {
  NAVIGATION_CLICKED: "navigation_clicked",
  MODAL_OPENED: "modal_opened",
  MODAL_CLOSED: "modal_closed",
  CTA_CLICKED: "cta_clicked",
} as const;

const ErrorEvents = {
  ERROR_ENCOUNTERED: "error_encountered",
  FORM_VALIDATION_FAILED: "form_validation_failed",
  ACTION_FAILED: "action_failed",
} as const;

const BusinessEvents = {
  UPGRADE_PROMPT_VIEWED: "upgrade_prompt_viewed",
  PRICING_VIEWED: "pricing_viewed",
  UPGRADE_INITIATED: "upgrade_initiated",
  TRIAL_PROMPT_VIEWED: "trial_prompt_viewed",
  TRIAL_STARTED: "trial_started",
  SUBSCRIPTION_STARTED: "subscription_started",
  SUBSCRIPTION_CHANGED: "subscription_changed",
  SUBSCRIPTION_CANCELLED: "subscription_cancelled",
  FEEDBACK_SUBMITTED: "feedback_submitted",
  SUPPORT_CONTACTED: "support_contacted",
} as const;

const SettingsEvents = {
  SETTINGS_PAGE_ACCESSED: "settings_page_accessed",
  SETTINGS_UPDATED: "settings_updated",
  PROFILE_IMAGE_UPLOADED: "profile_image_uploaded",
} as const;

const LegacyEvents = {
  ACCOUNT_CREATED: "account_created",
  LOGIN_ATTEMPTED: "login_attempted",
  FEATURE_COMING_SOON: "feature_coming_soon",
} as const;

export const EventType = {
  ...AuthEvents,
  ...OnboardingEvents,
  ...CheckoutEvents,
  ...TriageEvents,
  ...EssentialsEvents,
  ...ActivationEvents,
  ...TaskEvents,
  ...DocumentEvents,
  ...PeopleEvents,
  ...AttorneyEvents,
  ...FeatureUsageEvents,
  ...NavigationEvents,
  ...ErrorEvents,
  ...BusinessEvents,
  ...SettingsEvents,
  ...LegacyEvents,
} as const;
